<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { viewComponentRegistry } from 'src/components/Sidepanel/view-registry';

	export let device: Device;

	/**
	 * RAEX is a dedicated cover motor. The old drawer always showed the
	 * position slider; the roller basic view does not, so always use advanced.
	 */
	$: component = viewComponentRegistry?.['roller']?.['advanced'];
</script>

{#if component}
	<svelte:component this={component} {device} />
{/if}
